export enum EFacetClassification {
  TAGS = 'tags',
  RUBRICS = 'rubrics',
}
